import { Country } from '../../../API/Enums';
import { FormatAsCurrencyFunction } from './formatAsCurrency.types';

/**
 * The `formatAsCurrency` function formats a number as a localized currency string. Returns an
 * empty string when `num` is nullish, or when `nonZeroOnly` is `true` and `num` is not positive.
 *
 * To view the type definition, click {@link FormatAsCurrencyFunction here}.
 */
export const formatAsCurrency: FormatAsCurrencyFunction = (num, nonZeroOnly = false, country = Country.USA) => {
    // TODO: localize
    if (num !== null && num !== undefined && (num > 0 || !nonZeroOnly)) {
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: country === Country.Canada ? 'CAD' : 'USD',
        });

        return formatter.format(num);
    }

    return '';
};
